import Permissions from "../../models/Permissions";

const AuditoriaSpedFiscal = () => import("./Index.vue");
const AuditoriaSaida = () => import("./Saida.vue");
const AuditoriaEntrada = () => import("./Entrada.vue");

const permissions = [
  Permissions.COLABORADOR,
  Permissions.GESTOR,
  Permissions.ADMINISTRADOR,
];

const children = [
  {
    path: "entrada",
    name: "auditoria.entrada",
    component: AuditoriaEntrada,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      showInMenu: true,
      label: "Entrada",
      icon: "fa fa-chevron-down",
      group: "Auditoria",
      permissions,
    },
  },
  {
    path: "saida",
    name: "auditoria.saida",
    component: AuditoriaSaida,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      showInMenu: true,
      label: "Saída",
      icon: "fa fa-chevron-up",
      group: "Auditoria",
      permissions,
    },
  },
];

export default [
  {
    path: "/AuditoriaSpedFiscal",
    name: "AuditoriaSpedFiscal",
    component: AuditoriaSpedFiscal,
    meta: {
      requiresAuth: true,
      requiresCompany: false,
      showInMenu: true,
      label: "SPED Fiscal",
      icon: "fa fa-files-o",
      group: "Auditoria",
      permissions,
    },
    children,
  },
];
